import React, { useContext, useState } from 'react';
import { Col, Form, Input, Row, Select, Radio } from 'antd';
import PropTypes from 'prop-types';
import { InfoCircleOutlined } from '@ant-design/icons';
import formUtil from '../../../../../../../../../utils/form';
import newCi from '../../../../../../../../../assets/images/help/new CI.svg';
import CustomTooltip from '../../../../../../../../../components/common/CustomTooltip';
import useMobileBreakpoint from '../../../../../../../../../hooks/useMobileBreakpoint';
import useParams from '../../../../../../../../params/useParams';
import paramEndpoints from '../../../../../../../../params/paramEndpoints';
import StrDatePicker from '../../../../../../../../../components/common/inputs/StrDatePicker';
import { EnrollmentFormContext } from '../../../../../../../../../providers/EnrollmentFormContextProvider';

// eslint-disable-next-line no-unused-vars
const LegalRepresentative = ({ gutter, title, index }) => {
  const [sexes, areSexesLoading] = useParams(paramEndpoints.SEXES);
  const [countries, areCountriesLoading] = useParams(paramEndpoints.COUNTRIES);
  const [relations, areRelationsLoading] = useParams(paramEndpoints.VANTRUST_RELATIONS);
  const [selectedRelation, setSelectedRelation] = useState(false);

  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const isMobile = useMobileBreakpoint();

  const toggleRadioRelation = () => {
    setSelectedRelation(true);
  };

  const toggleRadioRelationFalse = () => {
    setSelectedRelation(false);
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <p className="personalDocumentsForm__title">{title}</p>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'sex']}
            label="Sexo"
            rules={[{ required: true, message: 'Dato requerido' }]}
          >
            <Select loading={areSexesLoading} disabled={areSexesLoading}>
              {sexes.map((sex) => (
                <Select.Option key={sex.id} value={sex.id}>
                  {sex.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'nationality']}
            label="Nacionalidad"
            rules={[{ required: true, message: 'Dato requerido' }]}
          >
            <Select loading={areCountriesLoading} disabled={areCountriesLoading}>
              {countries.map((country) => (
                <Select.Option key={country.id} value={country.id}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'dateOfBirth']}
            label="Fecha de nacimiento"
            rules={[{ required: true, message: 'Dato requerido' }]}
          >
            <StrDatePicker
              defaultPickerValue={formUtil.date.defaultValue.yearsAgo(30)}
              showToday={false}
              disabledDate={formUtil.date.dateDisablers.disabledDate()}
              format={formUtil.date.format.day}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'serialNumber']}
            label={
              <>
                <span>Número de Serie de CI </span>
                {isMobile ? (
                  <div style={{ marginLeft: 10 }}>
                    <CustomTooltip
                      placement="top"
                      title={<img src={newCi} alt="carnet nuevo" style={{ width: '100%' }} />}
                    >
                      <InfoCircleOutlined style={{ color: '#B22938', fontSize: '20px' }} />
                    </CustomTooltip>
                  </div>
                ) : null}
              </>
            }
            rules={[{ required: true, len: 9 }]}
          >
            <Input />
          </Form.Item>
        </Col>
        {isMobile ? null : (
          <Col lg={12} xs={24}>
            <Row style={{ marginTop: '10%' }}>
              <Col lg={2} xs={3}>
                <InfoCircleOutlined style={{ color: '#B22938', fontSize: '20px' }} />
              </Col>
              <Col lg={22} xs={21}>
                <CustomTooltip
                  placement="top"
                  title={<img src={newCi} alt="carnet nuevo" style={{ width: '100%' }} />}
                >
                  <p>¿Dónde encuentro mi número de documento/serie?</p>
                </CustomTooltip>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <Row>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'professionJob']}
            label="Profesión u oficio"
            rules={[{ required: true, message: 'Dato requerido' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col lg={15} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'hasVantrustRelation']}
            label="¿Tiene alguna relación con VanTrust o sus empleados?"
            rules={[{ required: true, message: 'Dato requerido' }]}
          >
            <Radio.Group>
              <Radio value onChange={toggleRadioRelation}>
                Si
              </Radio>
              <Radio value={false} onChange={toggleRadioRelationFalse}>
                No
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {selectedRelation ? (
        <Row gutter={gutter}>
          <Col lg={12} xs={24}>
            <Form.Item
              name={['legalRepresentatives', index, 'vantrustRelation']}
              label="Seleccionar cargo"
              rules={[
                {
                  required: true,
                  message: 'Dato requerido',
                },
              ]}
            >
              <Select loading={areRelationsLoading} disabled={areRelationsLoading}>
                {relations.map((relation) => (
                  <Select.Option key={relation.name} value={relation.id}>
                    {relation.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col lg={12} xs={24}>
            <Form.Item shouldUpdate noStyle>
              {() =>
                enrollmentForm.getFieldValue([
                  'legalRepresentatives',
                  index,
                  'vantrustRelation',
                ]) === '(7) OTRAS-PERSONAS' && (
                  <Form.Item
                    name={['legalRepresentatives', index, 'otherVantrustRelation']}
                    label={' '}
                    rules={[
                      {
                        required: true,
                        message: 'Dato requerido',
                      },
                    ]}
                    required={false}
                  >
                    <Input placeholder="especifique" />
                  </Form.Item>
                )
              }
            </Form.Item>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

LegalRepresentative.propTypes = {
  gutter: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
};

export default LegalRepresentative;
